import { notification } from 'antd';
import React from 'react';
import styles from "../../shared/widgets/pushNotification/pushnotification.module.scss";
import { showBrowserNotification } from '../../base/notification';
import moment from "moment";
import { RRuleTimeCal } from '../../base/meetingService/utils/meetingServices';
import Group from "../../styles/images/videoIcon.svg";
import { updateMeetingRead, updateMeetingTotalBatch } from '../../base/meetingService/apiService';
import { storeCurrentMeetingDetail, storeMeetingPage, storePreviousMeetingDetail, storeWindowState } from '../../base/meetingService/meetingStoreServices';
import store from '../../context/store/store';
import { UserDetails } from '../../models/model';
import { toastInformation } from '../../base/callService/common';
import { config } from '../../base/constant';
import _ from 'lodash';
import { Types } from '../../context/action/action';
//import { style } from 'wavesurfer.js/src/util';
// type meetListState = {
//   isClear: boolean;
//   meetingListState: any;
//   filterType: string;
//   tempList: any;
//   doneList: any;
//   isModalVisible: boolean;
//   isCopyModal: boolean;
// };

export const Meetingnotifications = (placement: any,data: any, location: any) => {
  const {currentMeetingDetailPage } = store.getState().meetingReducer || [];
  const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
    notification.config({
      duration: 11
    });
    const currentDate =  moment(new Date()).format("YYYY-M-DD");
    const currentTimeStamp=Date.now();  /// Current Timestamp
     const startDate = moment(data.createdDate);
     const timeEnd = moment(currentTimeStamp);
     const diff = timeEnd.diff(startDate);
     const diffDuration = moment.duration(diff);
    //const meetingScheduleCreatedDate= diffDuration.minutes() === 0 ? 'Now' : diffDuration.minutes() <= 60 ? diffDuration.minutes()+' min ago' : diffDuration.minutes() <= 120 ? 'Yesterday' : timestampCreatedDate;
     const meetingScheduleCreatedDate=diffDuration.minutes() === 0 ? 'Now' : '1 min ago';
     const notifctionStartDate= moment(new Date(data.start_timestamp)).format("YYYY-M-DD");
     const invitDatetime= data.notification_type === 3 ? 'In 5 Minutes' : data.notification_type === 2 ? 'In 15 Minutes' : currentDate !== notifctionStartDate ?
     (moment (new Date(data.start_timestamp)).format('DD MMM YYYY')) : 
     (moment(data.start_timestamp).format('hh:mm A')) + ' - ' +
     (moment(data.rrule !== "" ? RRuleTimeCal(data.start_timestamp, data.duration_minutes) : data.end_timestamp).format('hh:mm A'));
     const invitmin = currentDate !== notifctionStartDate ? (moment(data.start_timestamp).format('hh:mm A')) : data.duration_minutes+' min';
     const inputOptions = {
      userName: data.title,
      url: data.invite_url,
      message: 'Invitation From '+data.hostName+' (Host) \n'+invitDatetime+'  \u2022  '+invitmin
    };
    notification.open({
      className: "notificationbannerConsec",
      message: " ",
      description: (
        <>
          <div className={styles.notificongridmain}>
           <div className={styles.notificongrid} onClick={() => setDetailPage(data, location)}>
            <div className={styles.notifilftimg}>
              <img src={Group} alt=""/>           
            </div>
            <div className={styles.notificationConsec}>    
              <div className={styles.notificationtopdes}>          
                <span>
                  Meeting  -  {meetingScheduleCreatedDate}
                </span>
              </div>
              <div className={styles.notifitopheader}>
                <h3>{data.title}</h3>
                <h4>Invitation From <span className={styles.userName}>{data.hostName}</span> (Host)</h4>
              </div>
              <div className={styles.notificationtimesec}>
                <h3 className={styles.notifitxticontxt}>
                <span className={currentDate!==notifctionStartDate ?"icon_Calendar" : "icon_clock"}></span>
                {invitDatetime}<span className={currentDate!==notifctionStartDate ?"icon_clock" : "icon_timer"}></span>{currentDate!==notifctionStartDate ? (moment(data?.start_timestamp).format('hh:mm A')) : data?.duration_minutes+' min'}</h3>
              </div>
                </div>
              </div>
              <div className={styles.notificationmeetstats} >
              {currentDate===notifctionStartDate && <span onClick={()=> openLink(data)}>{loggedUser?.sip_login_id===data?.sip_id ? "Start meeting" : "Join Meeting  "} </span> }
              {currentDate===notifctionStartDate &&<span className={styles.dotClass}>.</span>}
              {currentDate===notifctionStartDate &&<span onClick={() => copyInvitationModal(data)}>  Copy invitation</span>}
            </div>
          </div>
        </>
      ),
    placement
    });
    if (document.visibilityState === 'visible'){
        //console.log('has focus');
        showBrowserNotification(inputOptions, 'meeting');
    } else {
        //console.log('lost focus');
        showBrowserNotification(inputOptions, 'meeting');
    }

  
  const copyInvitationModal = (data:any) => {  
    const str = data.hostName + " is invite you to a Worktual meeting. \n \n"+
    "Topic: \n" + data.title + "\n \n" +
    "Time: \n" + moment(data.start_timestamp).format("DD MMM YYYY hh:mm A") + "\n \n" +
    "Duration: \n" + data.duration_minutes + " min \n \n" +
    "Join Worktual Meeting: \n" + data.invite_url + "\n \n \n" +
    "Meeting ID : \n"  + data.meeting_id;
    navigator.clipboard.writeText(str);
    toastInformation(config().COPYINVITATION);
  };

  const openLink = (url: any) => {
   let inviteUrl:any = url?.invite_url;
   store.dispatch({
    type: Types.VIDEOMEET_COUNT_STATUS,
    payload: {
      meetingCountStatus:true
    }
  })
  updateMeetingRead(url?.uuid);
    window.open(inviteUrl,'_blank');
  };

  const setDetailPage = (list: any, location: any) => {
    // storeMeetingPage(list);
    //console.log('location on ---  ',location);
    location.push("/meeting")
    //console.log("Set DETAILS CALLING>>>>>");
    store.dispatch({
      type: Types.VIDEOMEET_COUNT_STATUS,
      payload: {
        meetingCountStatus:true
      }
    })
    updateMeetingRead(list?.uuid);
      if(!_.isEmpty(currentMeetingDetailPage)){
        storeMeetingPage(list);
        storePreviousMeetingDetail(currentMeetingDetailPage);
        storeCurrentMeetingDetail(list);
      }
      else{
        storeCurrentMeetingDetail(list);
        storeMeetingPage(list)
      }
      storeWindowState("meetingDetails");
  };
 
  return (<></>);
};